<template>
  <v-container>
    <!-- 신규등록시 일반회원으로 설정-->
    <!-- 다른 타입의 회원정보는 수정만 가능 -->
    <v-dialog v-model="openFlag" persistent max-width="600px">
      <c-card class="white" :title="onDialogTitle">
        <div class="mt-2">
          <span class="red--text">*</span> 는 필수입력항목입니다.
        </div>
        <v-form lazy-validation ref="form">

          <v-container>
            <v-row align="center">
              <v-col class="mx-0 px-0" cols="12">
                <h3>인적사항</h3>
              </v-col>

              <v-col cols="7">
                <span class="ml-1">이름</span><span class="red--text">*</span>
                <v-text-field class="my-3" v-model="name" placeholder="이름을 입력해주세요" solo dense required :rules="[v => !!v]" maxLength="32"
                              hide-details color="navy" maxlength="32"/>
              </v-col>

              <v-col cols="5">
                <span class="ml-1">성별</span><span class="red--text">*</span>
                <v-radio-group
                  v-model="gender"
                  row
                  required :rules="[v => !!v]"
                >
                  <v-radio label="남자" value="M"></v-radio>
                  <v-radio label="여자" value="F"></v-radio>
                </v-radio-group>
              </v-col>

              <v-col cols="12">
                <span class="ml-1 mb-2">생년월일</span><span class="red--text">*</span>
                <v-row class="my-3" justify="space-around">
                  <v-select
                    class="customer-cu-select"
                    dense
                    v-model="birthYear"
                    :items="selectYears"
                    solo
                    menu-props="{ offsetY: true}"
                    hide-details
                    required
                    :rules="[v => !!v]"
                    label="년도"
                    color="navy"
                  ></v-select>

                  <v-select
                    class="customer-cu-select"
                    dense
                    v-model="birthMonth"
                    :items="selectMonths"
                    solo
                    menu-props="{ offsetY: true}"
                    hide-details
                    required
                    :rules="[v => !!v]"
                    label="월"
                    color="navy"
                  ></v-select>

                  <v-select
                    class="customer-cu-select"
                    dense
                    style="width:50px"
                    v-model="birthDay"
                    :items="selectDays"
                    solo
                    menu-props="{ offsetY: true}"
                    hide-details
                    required
                    :rules="[v => !!v]"
                    label="일"
                    color="navy"
                  ></v-select>
                </v-row>
                <span class="red--text" v-if="customerFormData && customerFormData.customerType && customerFormData.customerType.configValue === 'ct_baby'">생년월일 변경시 회원에게 발급된 바우처 만료일이 변경됩니다.</span>
                <v-divider class="mt-3"></v-divider>
              </v-col>

              <v-col cols="12" v-if="customerFormData && customerFormData.customerType && customerFormData.customerType.configValue === 'ct_pregnant'">
                <span class="ml-1 mb-2">분만 예정일</span><span class="red--text">*</span>
                <v-row justify="space-around" class="mb-1">
                  <v-select
                    class="customer-cu-select"
                    dense
                    v-model="expectedDeliveryDateYear"
                    :items="selectPrgnantYears"
                    solo
                    menu-props="{ offsetY: true}"
                    hide-details
                    required
                    :rules="[v => !!v]"
                    label="년도"
                    color="navy"
                  ></v-select>

                  <v-select
                    class="customer-cu-select"
                    dense
                    v-model="expectedDeliveryDateMonth"
                    :items="selectMonths"
                    solo
                    menu-props="{ offsetY: true}"
                    hide-details
                    required
                    :rules="[v => !!v]"
                    label="월"
                    color="navy"
                  ></v-select>

                  <v-select
                    class="customer-cu-select"
                    dense
                    style="width:50px"
                    v-model="expectedDeliveryDateDay"
                    :items="selectDays"
                    solo
                    menu-props="{ offsetY: true}"
                    hide-details
                    required
                    :rules="[v => !!v]"
                    label="일"
                    color="navy"
                  ></v-select>
                </v-row>
                <span class="red--text">분만 예정일 변경시 회원에게 발급된 바우처 만료일이 변경됩니다.</span>
                <v-divider class="mt-3"></v-divider>
              </v-col>

              <v-col cols="12">
                <span class="ml-1 mb-2">연락처</span><span class="red--text" v-if="!isOff">*</span>
                <v-row align="center">
                  <v-col cols="9" class="my-0 py-0">
                    <v-row justify="space-around" align="center" v-if="!isOff">
                      <v-col cols="3" class="mr-0 pr-0">
                        <v-text-field v-model="mobileNo1" v-mask="['##','###']" solo hide-details required :rules="[v => !!v]" dense color="navy"></v-text-field>
                      </v-col>
                      <v-col cols="1" class="px-0 mx-0 text-center font-weight-bold"><span>-</span></v-col>
                      <v-col cols="3" class="mx-0 px-0">
                        <v-text-field id="mobileNo2C" v-model="mobileNo2" v-mask="['###','####']" solo hide-details required :rules="[v => !!v]" dense color="navy"></v-text-field>
                      </v-col>
                      <v-col cols="1" class="px-0 mx-0 text-center font-weight-bold"><span>-</span></v-col>
                      <v-col cols="3" class="ml-0 pl-0">
                        <v-text-field id="mobileNo3C" v-model="mobileNo3" v-mask="['####']" solo hide-details required :rules="[v => !!v]" dense color="navy"></v-text-field>
                      </v-col>
                    </v-row>

                    <v-row justify="space-around" align="center" v-if="isOff">
                      <v-col cols="3" class="mr-0 pr-0">
                        <v-text-field v-model="mobileNo1" v-mask="['##','###']" solo hide-details dense color="navy"></v-text-field>
                      </v-col>
                      <v-col cols="1" class="px-0 mx-0 text-center font-weight-bold"><span>-</span></v-col>
                      <v-col cols="3" class="mx-0 px-0">
                        <v-text-field id="mobileNo2C" v-model="mobileNo2" v-mask="['###','####']" solo hide-details dense color="navy"></v-text-field>
                      </v-col>
                      <v-col cols="1" class="px-0 mx-0 text-center font-weight-bold"><span>-</span></v-col>
                      <v-col cols="3" class="ml-0 pl-0">
                        <v-text-field id="mobileNo3C" v-model="mobileNo3" v-mask="['####']" solo hide-details dense color="navy"></v-text-field>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="3" class="my-0 py-0">
                    <c-btn color="blue" outlined @click="reqMobileDupl" :disabled="mobileNoBtnFlag">중복검사</c-btn>
                  </v-col>
                </v-row>


                <v-divider class="mt-3"></v-divider>
              </v-col>

              <v-col cols="12">
                <span class="ml-1 mb-2">이메일</span>
                <v-text-field class="my-3" v-model="email" placeholder="example@email.com" solo required
                              hide-details color="navy" maxLength="100"></v-text-field>

                <v-divider class="mt-3"></v-divider>
              </v-col>

              <v-col cols="12">
                <div class="ml-1 mb-2">주소</div>
                <v-text-field
                  v-model="address"
                  placeholder="주소를 입력해주세요"
                  :autofocus="true"
                  color="navy"
                  readonly clearable
                  maxLength="128"
                  @click="setAddress()"
                  solo required hide-details></v-text-field>
                <div class="ml-1 mt-2 mb-2">상세 주소</div>
                <v-text-field
                  v-model="addressDetails"
                  placeholder="상세주소를 입력해주세요"
                  :autofocus="true"
                  color="navy"
                  maxLength="128"
                  solo required hide-details></v-text-field>
              </v-col>
            </v-row>

            <v-divider class="mt-3"></v-divider>

            <v-row align="center">
              <v-col class="mx-0 px-0 mt-2" cols="12">
                <h3>회원 유형 정보</h3>
              </v-col>

              <v-col cols="12">
                <span class="ml-1 mb-2">회원 유형</span><span class="red--text">*</span>
                <v-radio-group
                  v-model="selectedCustomerType"
                  row
                  required :rules="[v => !!v]"
                  :disabled="disableCustomerType"
                >
                  <v-radio label="일반" value="ct_normal"></v-radio>
                  <v-radio label="교통약자" value="교통약자"></v-radio>
                  <v-select
                    class="customer-cu-select"
                    dense
                    v-model="selectedOthersCustomerType"
                    :items="othersCustomerTypeList"
                    solo
                    menu-props="{ offsetY: true}"
                    hide-details
                    :rules="[v => selectedCustomerType !== '교통약자' || !!v]"
                    label="교통약자 유형"
                    color="navy"
                    :disabled="selectedCustomerType !== '교통약자'"
                  ></v-select>
                  <v-radio label="보호자" value="ct_guardian"></v-radio>
                </v-radio-group>
              </v-col>

              <template v-if="selectedCustomerType === '교통약자' && selectedOthersCustomerType === 'ct_mobility_week'">
                <v-col cols="12">
                  <span class="ml-1 mb-2 mr-1">장애 유형 및 정도</span><span class="red--text pr-1">*</span>
                  <c-btn class="family-contract--add" color="blue" outlined @click="onAddHandicapInfo()">추가</c-btn>
                  <template v-for="(handicapInfo, idx) in input.handicapInfoList">
                    <v-col cols="12">
                      <v-row justify="space-around" align="center">
                        <v-select
                          class="customer-cu-select"
                          dense
                          v-model="handicapInfo.type"
                          :items="handicapTypeList"
                          solo
                          menu-props="{ offsetY: true}"
                          hide-details
                          required
                          :rules="[v => !!v]"
                          label="장애유형"
                          color="navy"
                        ></v-select>

                        <v-col cols="3" class="mx-0 px-0">
                          <v-text-field v-model="handicapInfo.etcType"
                                        label="직접 입력"
                                        :rules="[v => handicapInfo.type !== '직접입력' || !!v]"
                                        :disabled="handicapInfo.type !== '직접입력'"
                                        solo hide-details required dense color="navy"/>
                        </v-col>

                        <v-select
                          class="customer-cu-select"
                          dense
                          style="width:50px"
                          v-model="handicapInfo.degree"
                          :items="handicapDegreeList"
                          solo
                          menu-props="{ offsetY: true}"
                          hide-details
                          required
                          :rules="[v => !!v]"
                          label="장애정도"
                          color="navy"
                        ></v-select>
                        <c-btn color="blue" @click="onRemoveHandicapInfo(idx)" icon iconName="cancel"/>
                      </v-row>
                    </v-col>
                  </template>
                  <v-divider class="mt-3"></v-divider>

                </v-col>

                <v-col cols="7">
                  <span class="ml-1 mb-2">휠체어 유무</span><span class="red--text">*</span>
                  <v-radio-group
                    v-model="selectedWheelchair"
                    row dense
                  >
                    <v-radio label="전동" value="전동"></v-radio>
                    <v-radio label="수동" value="수동"></v-radio>
                    <v-radio label="없음" value="없음"></v-radio>
                  </v-radio-group>
                </v-col>
                <v-col cols="5">
                  <span class="ml-1 mb-2">의사소통 가능 여부</span><span class="red--text">*</span>
                  <v-radio-group
                    v-model="selectedCommunicable"
                    row dense
                  >
                    <v-radio dense label="가능" :value=true></v-radio>
                    <v-radio dense label="불가능" :value=false></v-radio>
                  </v-radio-group>
                </v-col>

                <v-col cols="7">
                  <span class="ml-1 mb-2">일상생활 상태</span><span class="red--text">*</span>
                  <v-radio-group
                    v-model="selectedLifeStatus"
                    row dense
                  >
                    <v-radio class="mx-1 px-0" label="완전 도움" value="완전도움"></v-radio>
                    <v-radio class="mx-1 px-0" label="부분 도움" value="부분도움"></v-radio>
                    <v-radio class="mx-1 px-0" label="독립" value="독립"></v-radio>
                  </v-radio-group>
                </v-col>
                <v-col cols="5">
                  <span class="ml-1 mb-2">기초생활수급자 여부</span><span class="red--text">*</span>
                  <v-radio-group
                    v-model="selectedBasicLivelihood"
                    row dense
                  >
                    <v-radio label="예" :value=true></v-radio>
                    <v-radio label="아니요" :value=false></v-radio>
                  </v-radio-group>
                </v-col>

                <v-col cols="12">
                  <span class="mx-1 mb-2">비상연락망</span>
                  <c-btn class="family-contract--add" color="blue" outlined @click="onAddFamilyContact()">추가</c-btn>
                </v-col>

                <template v-for="(familyContact, idx) in familyContactList">
                  <v-col cols="12">
                    <v-row justify="space-around" align="center">
                      <v-text-field
                        v-model="familyContact.no1" v-mask="['##','###']"
                        :rules="[v => (!familyContact.no2 && !familyContact.no3 && !familyContact.relation) || !!v]"
                        class="customer-cu-em_phone"

                        solo hide-details required dense color="navy" />
                      <span class="font-weight-bold">-</span>
                      <v-text-field
                        class="customer-cu-em_phone"
                        v-model="familyContact.no2" v-mask="['###','####']"
                        :rules="[v => (!familyContact.no1 && !familyContact.no3 && !familyContact.relation) || !!v]"
                        solo hide-details required dense color="navy"/>
                      <span class="font-weight-bold">-</span>
                      <v-text-field
                        class="customer-cu-em_phone"
                        v-model="familyContact.no3" v-mask="['####']"
                        :rules="[v => (!familyContact.no2 && !familyContact.no3 && !familyContact.relation) || !!v]"
                        solo hide-details required dense color="navy"/>
                      <v-select
                        dense
                        style="width:80px"
                        v-model="familyContact.relation"
                        :items="familyContactRelationList"
                        solo
                        menu-props="{ offsetY: true}"
                        hide-details
                        required
                        :rules="[v => !familyContact.no1 || !familyContact.no2 || !familyContact.no3 || !!v]"
                        label="관계"
                        color="navy"
                      />
                      <c-btn color="blue" @click="onRemoveFamilyContact(idx)" icon iconName="cancel"/>
                    </v-row>
                  </v-col>
                </template>
              </template>

              <template v-if="isUpdated">
                <v-col class="mx-0 px-0 mt-2 mb-0 pb-0" cols="12">
                  <h3>활성상태</h3>
                </v-col>
                <v-col class="mt-0 pt-0" cols="12">
                  <v-radio-group v-model="active" row>
                    <v-radio label="활성" value="Enable"></v-radio>
                    <v-radio label="비활성" value="Disable"></v-radio>
                  </v-radio-group>
                </v-col>
              </template>

            </v-row>
            <v-row justify="center">
              <c-btn class="mr-1 mt-2" v-if="isUpdated" color="blue" outlined @click="onAddOrUpdateCustomer">수정</c-btn>
              <c-btn v-else class="mr-1 mt-2" color="blue" outlined @click="onAddOrUpdateCustomer">등록</c-btn>
              <c-btn class="mt-2" color="gray" outlined @click="openFlag = false">취소</c-btn>
            </v-row>
          </v-container>
        </v-form>

      </c-card>
    </v-dialog>
  </v-container>
</template>
<script>
  import { mask } from 'vue-the-mask';

  const BASE_BIRTH_YEAR = 1900;

  export default {
    directives: { mask },

    props: {
      open: {
        type: Boolean,
        default: false
      },
      customerFormData: {
        type: Object | Array,
        default: undefined
      }
    },

    data: () => ({
      openFlag: false,

      // customerInfo
      name: '',
      gender: '',
      active: 'Enable',
      address: '',
      addressDetails: '',
      addressLat: 0,
      addressLng: 0,
      birthYear: '',
      birthMonth: '',
      birthDay: '',
      expectedDeliveryDateYear: '',
      expectedDeliveryDateMonth: '',
      expectedDeliveryDateDay: '',
      mobileNo: '',
      mobileNo1: '',
      mobileNo2: '',
      mobileNo3: '',
      email: '',
      registerType: '',
      isOff : true,

      isUpdated: false,

      selectYears: [],
      selectMonths: [],
      selectDays: [],
      mobileNoFlag: false,
      mobileNoRegx: /^(01[16789]|02|0[3-9][0-9])-[0-9]{3,4}-[0-9]{4}$/,
      mobileNoRegx010: /^(010)-[0-9]{4}-[0-9]{4}$/,
      emailRegx: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/i,


      selectedCustomerType: 'ct_normal',  // 교통약자, ct_guardian
      othersCustomerTypeList: [
        {text: '장애인', value: 'ct_mobility_week'},
        {text: '임산부', value: 'ct_pregnant'},
        {text: '영유아 가정', value: 'ct_baby_family'},
        {text: '영유아', value: 'ct_baby'},
        {text: '고령자', value: 'ct_elders'},
      ],
      selectedOthersCustomerType: '', // 회원 유형

      handicapTypeList: [
        {text: '간', value:'간'},
        {text: '뇌전증', value:'뇌전증'},
        {text: '뇌병변', value:'뇌병변'},
        {text: '시각', value:'시각'},
        {text: '신장', value:'신장'},
        {text: '심장', value:'심장'},
        {text: '안면', value:'안면'},
        {text: '언어', value:'언어'},
        {text: '자폐성', value:'자폐성'},
        {text: '장루, 요루', value:'장루,요루'},
        {text: '정신', value:'정신'},
        {text: '지적', value:'지적'},
        {text: '지체', value:'지체'},
        {text: '청각', value:'청각'},
        {text: '호흡기', value:'호흡기'},
        {text: '일시적 장애', value:'일시적장애'},
        {text: '직접입력', value:'직접입력'}
      ],
      handicapDegreeList: [{text: '심함', value: '심함'}, {text: '심하지 않음', value: '심하지않음'}, {text: '기타', value: '기타'}],
      input: {
        handicapInfoList: [
          {
            type: '',
            etcType: '',
            degree: '',
          }
        ],
      },

      selectedWheelchair: '전동',
      selectedCommunicable: true,
      selectedBasicLivelihood: true,
      selectedLifeStatus: '완전도움',



      familyContactList: [{no1: '', no2: '', no3: '', relation: ''}],
      familyContactRelationList: [
        {text: '가족', value:'가족'},
        {text: '친구, 지인', value:'친구,지인'},
        {text: '복지사', value:'복지사'},
        {text: '기타', value:'기타'}
      ],
      disableCustomerType: false,

    }),

    watch: {
      open(value) {
        this.initData();
        if(value && this.customerFormData) {
          if (this.customerFormData.id ) {
            this.isUpdated = true;
          }

          const {name, address, addressDetails,
            gender, active, email, mobileNo, registerType, birth, expectedDeliveryDate,
            customerType, mobilityWeakInfo, familyContactList
          } = this.customerFormData;


          this.name = name ? name : "";
          this.address = address ? address : "";
          this.addressDetails = addressDetails ? addressDetails : '';
          this.gender = gender ? gender : "";
          this.active = active;
          this.email = email ? email : "";

          const splitMobileNo = mobileNo ? mobileNo.split('-') : [];
          if(splitMobileNo.length > 0) {
            this.mobileNo1 = splitMobileNo[0];
            this.mobileNo2 = splitMobileNo[1];
            this.mobileNo3 = splitMobileNo[2];

          } else {
            this.mobileNo1 = "";
            this.mobileNo2 = "";
            this.mobileNo3 = "";
          }

          this.isOff = registerType === null || registerType === 'm.off';

          if (birth) {
            const birthArr = this.customerFormData.birth.split('-');
            this.birthYear = parseInt(birthArr[0]);
            this.birthMonth = birthArr[1];
            this.birthDay = birthArr[2];
          }

          if(expectedDeliveryDate) {
            const dateArr = this.customerFormData.expectedDeliveryDate.split('-');
            this.expectedDeliveryDateYear = parseInt(dateArr[0]);
            this.expectedDeliveryDateMonth = dateArr[1];
            this.expectedDeliveryDateDay = dateArr[2];
          }

          const isOthersCustomerType = customerType && customerType.configValue !== 'ct_normal' && customerType.configValue !== 'ct_guardian';
          if(isOthersCustomerType) {
            this.selectedCustomerType = '교통약자';
            this.selectedOthersCustomerType = customerType.configValue;

            //임산부 일 경우 선택 disabled
            if(customerType.configValue === 'ct_pregnant') {
              this.disableCustomerType = true;
            }
            // 교통약자 정보가 존재하는 경우 (장애인)
            if(mobilityWeakInfo && customerType.configValue === 'ct_mobility_week') {
              const {isBasicLivelihood, isCommunicable, handicapInfo, lifeStatus, wheelchair} = mobilityWeakInfo;
              this.selectedBasicLivelihood = isBasicLivelihood;

              const handicapInfoList = [];
              JSON.parse(handicapInfo).forEach(info => {
                const{type, degree} = info;
                const customerHandicapType = this.handicapTypeList.find(handicapType=> handicapType.value === type);
                  handicapInfoList.push({
                      type: customerHandicapType ? customerHandicapType.value : '직접입력',
                      etcType: customerHandicapType ? '' : type,
                      degree
                  })
              });
              this.input.handicapInfoList = handicapInfoList;
              this.selectedWheelchair = wheelchair;
              this.selectedCommunicable = isCommunicable;
              this.selectedLifeStatus = lifeStatus;

            }

          } else {
            this.selectedCustomerType = customerType ? customerType.configValue : 'ct_normal';
          }

          // 비상연락망 존재시
          if(familyContactList) {
            const parsedFamilyContactList = JSON.parse(familyContactList);
            if(parsedFamilyContactList.length > 0) {
              this.familyContactList = parsedFamilyContactList.map(contact => {
                const {phone, relation} = contact;
                const splitPhone = phone.split('-');
                return {no1: splitPhone[0], no2: splitPhone[1], no3: splitPhone[2], relation}
              });
            }
          }

        }
        this.openFlag = value;
      },
      openFlag(value) {
        this.$emit('update:open', value);
      },
      address(value) {
        if ( !value ) {
          this.address = "";
          this.addressLat = 0;
          this.addressLng = 0;
        }
      },
      birthYear(value) {
        if(this.birthMonth) {
          this.selectDays = this.getDaysOfMonth(value, this.birthMonth);
        }
      },
      birthMonth(value) {
        if(this.birthYear) {
          this.selectDays = this.getDaysOfMonth(this.birthYear, value);
        }
      },
      selectedCustomerType(newVal, oldVal) {
        if (newVal === '교통약자' && !this.selectedOthersCustomerType) {
          this.selectedOthersCustomerType = 'ct_mobility_week';
        }
      }
      // mobileNo1(value) {
      //   if(this.customerFormData === undefined){
      //     this.mobileNoFlag = false;
      //   }
      //   if(value === '02' || value.length === 3) {
      //     document.getElementById("mobileNo2C").focus()
      //   }
      // },
      // mobileNo2(value) {
      //   if(this.customerFormData === undefined){
      //     this.mobileNoFlag = false;
      //   }
      //   if(value.length === 4) {
      //     document.getElementById("mobileNo3C").focus()
      //   }
      // },
      // mobileNo3(value) {
      //   if(this.customerFormData === undefined){
      //     this.mobileNoFlag = false;
      //   }
      // },
    },

    computed: {
      getBtnName() {
        return this.isUpdated ? '수정' : '등록';
      },
      onDialogTitle() {
        return this.isUpdated ? '회원 정보 수정' : '회원 등록';
      },
      mobileNoBtnFlag() {
        if(this.customerFormData !== undefined){
          if(this.customerFormData.mobileNo === this.mobileNo1+ '-' + this.mobileNo2 + '-' + this.mobileNo3){
            this.mobileNoFlag = true;
            return true;
          } else {
            this.mobileNoFlag = false;
            return false;
          }
        }
      },
    },

    methods: {
      initData() {
        this.name = '';
        this.address = '';
        this.addressDetails = '';
        this.gender = '';
        this.active = 'Enable';
        this.mobileNo = '';
        this.email = '';
        this.mobileNo1 = '';
        this.mobileNo2 = '';
        this.mobileNo3 = '';
        this.birthYear = 1970;
        this.birthMonth = '01';
        this.birthDay = '01';
        this.registerType = '';
        this.isOff = true;
        this.expectedDeliveryDateYear = '';
        this.expectedDeliveryDateMonth = '';
        this.expectedDeliveryDateDay = '';

        this.selectedCustomerType = 'ct_normal';
        this.selectedOthersCustomerType = '';
        this.selectedHandicapType = '';
        this.etcHandicapType = '';
        this.selectedHandicapDegree = '';
        this.selectedWheelchair = '전동';
        this.selectedCommunicable = true;
        this.selectedBasicLivelihood = true;
        this.selectedLifeStatus = '완전도움';
        this.familyContactList = [{no1: '', no2: '', no3: '', relation: ''}];
        this.input.handicapInfoList = [{type: '', etcType: '', degree: ''}];
      },
      onAddHandicapInfo() {
        if(this.input.handicapInfoList.length > 2) return;
        this.input.handicapInfoList.push({type: '', etcType: '', degree: ''});
      },
      onRemoveHandicapInfo(idx) {
        if(idx > 0)
          this.input.handicapInfoList.splice(idx, 1);
      },
      onAddFamilyContact() {
        if(this.familyContactList.length > 2) return;
        this.familyContactList.push({no1: '', no2: '', no3: '', relation: ''});
      },
      onRemoveFamilyContact(idx) {
        this.familyContactList.splice(idx, 1);
      },
      validateInputData() {
        if (!(this.$refs.form.validate())) {
          this.$store.commit('snackbar', {timeout : 2000 ,msg: '비어있는 필드가 있습니다.'});
          return false;
        }

        if(this.email != '') {
          if (!this.emailRegx.test(this.email)) {
            this.$store.commit('snackbar', {timeout : 2000 ,msg: '이메일 주소를 확인해주세요.'});
            return false;
          }
        }

        const isMobileFilled = (this.mobileNo1.length > 0 || this.mobileNo2.length >0 || this.mobileNo3.length > 0)
        this.mobileNo = isMobileFilled ? this.mobileNo1+'-'+this.mobileNo2+'-'+this.mobileNo3 : '';

        //필수값은 아니지만, 값을 입력한경우 연락처 양식을 체크한다.
        if(this.isOff && isMobileFilled) {
          if(!this.mobileRegxCheck(this.mobileNo)) {
            this.$store.commit('snackbar', {timeout : 2000 ,msg: '연락처 양식이 올바르지 않습니다.'});
            return false;
          }
        }

        //온라인회원은 필수값이므로 연락처 양식을 체크한다.
        if(!this.isOff && !this.mobileRegxCheck(this.mobileNo)) {
          this.$store.commit('snackbar', {timeout : 2000 ,msg: '연락처 양식이 올바르지 않습니다.'});
          return false;
        }

        //필수값은 아니지만, 값을 입력한 상태에서 중복검사를 하지 않은경우 중복검사 알람을 띄워준다.
        if(this.isOff && isMobileFilled) {
          if(!this.mobileNoFlag) {
            this.$store.commit('snackbar', {timeout : 2000 ,msg: '연락처 중복검사를 해주세요.'});
            return false;
          }
        }

        if(!this.isOff && !this.mobileNoFlag) {
          this.$store.commit('snackbar', {timeout : 2000 ,msg: '연락처 중복검사를 해주세요.'});
          return false;
        }

        const birth = this.birthYear + '-' + this.birthMonth + '-' + this.birthDay;
        if(this.$moment().isBefore(this.$moment(birth))) {
          this.$store.commit('snackbar', {timeout : 2000 ,msg: '생년월일을 다시 확인해주세요.'});
          return false;
        }

        return true;
      },

      getMobilityWeakInputData() {
        let mobilityWeakInfo = null;
        if(this.selectedCustomerType === '교통약자' && this.selectedOthersCustomerType === 'ct_mobility_week') {

          const handicapInfo = [];
          // 장애 유형 및 정도 정보 병합
          this.input.handicapInfoList.forEach(info => {
            handicapInfo.push({
              type: info.type === '직접입력' ? info.etcType : info.type,
              degree: info.degree
            })
          });


          mobilityWeakInfo = {
            handicapInfo: JSON.stringify(handicapInfo),
            wheelchair: this.selectedWheelchair,
            isCommunicable: this.selectedCommunicable,
            isBasicLivelihood: this.selectedBasicLivelihood,
            lifeStatus: this.selectedLifeStatus,
          }

        }
        return mobilityWeakInfo;
      },

      getFamilyContactInputData() {
        const familyContactList = [];
        if(this.selectedCustomerType === '교통약자' && this.selectedOthersCustomerType === 'ct_mobility_week') {

          this.familyContactList.forEach(familyContact => {
            if(familyContact.no1 && familyContact.no2 && familyContact.no3 && familyContact.relation) {
              familyContactList.push({
                phone: familyContact.no1 + '-' + familyContact.no2 + '-' + familyContact.no3,
                relation: familyContact.relation
              });
            }
          });
        }
        return familyContactList;
      },

      onAddOrUpdateCustomer() {
        if(!this.validateInputData()) {
          return;
        }

        // 교통약자 정보
        const familyContactList = this.getFamilyContactInputData();
        const mobilityWeakInfo = this.getMobilityWeakInputData();
        const pregnantInfoReq = null;


        const birth = this.birthYear + '-' + this.birthMonth + '-' + this.birthDay;
        const customerTypeInfo = this.selectedCustomerType === '교통약자' ? this.selectedOthersCustomerType : this.selectedCustomerType;
        let reqData = {
          name: this.name,
          gender: this.gender,
          birth,
          mobileNo: this.mobileNo,
          email: this.email,
          address: this.address,
          addressDetails: this.addressDetails,
          addressLat: this.addressLat,
          addressLng: this.addressLng,

          customerTypeInfo,
          mobilityWeakInfo,
          pregnantInfoReq,

          familyContactList: familyContactList.length > 0 ? JSON.stringify(familyContactList) : null
        };

        if(this.isUpdated) {
          reqData = {
            ...reqData,
            id: this.customerFormData.id,
            active: this.active,
            expectedDeliveryDate : this.customerFormData.customerType && this.customerFormData.customerType.configValue === 'ct_pregnant' ? this.expectedDeliveryDateYear + '-' + this.expectedDeliveryDateMonth + '-' +this.expectedDeliveryDateDay : null,
            // expectedDeliveryDate : this.customerFormData.customerType && this.customerFormData.customerType.configValue === 'ct_pregnant' ? this.expectedDeliveryDateYear + '-' + this.expectedDeliveryDateMonth + '-' +this.expectedDeliveryDateDay : null,
          }
          this.$emit('reqUpdateCustomer', reqData);

        } else {
          this.$emit('reqAddCustomer', reqData);
        }

      },

      onAddCustomer() {
      },

      onUpdateCustomer() {
        if (!(this.$refs.form.validate())) {
          this.$store.commit('snackbar', {timeout : 2000 ,msg: '비어있는 필드가 있습니다.'});
          return;
        }

        this.mobileNo = this.mobileNo1+'-'+this.mobileNo2+'-'+this.mobileNo3;

        if(this.isOff && (this.mobileNo1.length > 0 || this.mobileNo2.length >0 || this.mobileNo3.length > 0)) {
          if(!this.mobileRegxCheck(this.mobileNo)) {
            this.$store.commit('snackbar', {timeout : 2000 ,msg: '연락처 양식이 올바르지 않습니다.'});
            return;
          }
        }
        if(!this.isOff && !this.mobileRegxCheck(this.mobileNo)) {
          this.$store.commit('snackbar', {timeout : 2000 ,msg: '연락처 양식이 올바르지 않습니다.'});
          return;
        }

        if(this.isOff && (this.mobileNo1.length > 0 || this.mobileNo2.length >0 || this.mobileNo3.length > 0)) {
          if(!this.mobileNoFlag) {
            this.$store.commit('snackbar', {timeout : 2000 ,msg: '연락처 중복검사를 해주세요.'});
            return;
          }
        }
        if(!this.isOff && !this.mobileNoFlag) {
          this.$store.commit('snackbar', {timeout : 2000 ,msg: '연락처 중복검사를 해주세요.'});
          return;
        }

        const birth = this.birthYear + '-' + this.birthMonth + '-' + this.birthDay;
        if(this.$moment().isBefore(this.$moment(birth))) {
          this.$store.commit('snackbar', {timeout : 2000 ,msg: '생년월일을 다시 확인해주세요.'});
          return;
        }
        const reqData = {
          id: this.customerFormData.id,
          name: this.name,
          gender: this.gender,
          birth: birth,
          mobileNo: this.mobileNo,
          email: this.email,
          address: this.address,
          addressDetails: this.addressDetails,
          addressLat: this.addressLat,
          addressLng: this.addressLng,

          active: this.active,
          expectedDeliveryDate : this.customerFormData.customerType && this.customerFormData.customerType.configValue === 'ct_pregnant' ? this.expectedDeliveryDateYear + '-' + this.expectedDeliveryDateMonth + '-' +this.expectedDeliveryDateDay : null,
        };
        this.$emit('reqUpdateCustomer', reqData);
      },

      getDaysOfMonth(year, month) {
        let days = [];
        const cntOfDays = 32 - new Date(year, month-1, 32).getDate();
        for(let i=1; i<=cntOfDays; i++) {
          if(i < 10) i = '0'+i;
          else i = i+'';
          days.push(i);
        }
        return days;
      },
      async reqMobileDupl() {
        try {
          if(!this.mobileNo1 || !this.mobileNo2 || !this.mobileNo3) {
            this.$store.commit('snackbar', {timeout : 2000, msg : '연락처를 입력해주세요.'});
            return;
          }

          this.mobileNo = this.mobileNo1+'-'+this.mobileNo2+'-'+this.mobileNo3;
          if(!this.mobileRegxCheck(this.mobileNo)) {
            this.$store.commit('snackbar', {timeout : 2000 ,msg: '연락처 양식이 올바르지 않습니다.'});
            return;
          }
          const response = await this.$api.customerMobileDulpCheck(this.mobileNo);
          if(response.data === true) {
            this.mobileNoFlag = true;
            this.$store.commit('snackbar', {timeout : 2000 ,msg : '등록 가능한 번호입니다.', color:'blue'});
          } else {
            this.$store.commit('snackbar', {timeout : 2000 ,msg : '이미 등록된 번호입니다.'});
            this.mobileNo = ''
          }
        }catch (err) {
          this.$store.commit('snackbar', {err, where:'reqMobileDupl'});
        }
      },
      mobileRegxCheck(number) {
        if(number === '') return true;
        const numberArray = number.split('-')
        if(numberArray[0] === '010') return this.mobileNoRegx010.test(number)
        else return this.mobileNoRegx.test(number)
      },
      setAddress(){

        // 주소-좌표 변환 객체 생성
        const geocoder = new kakao.maps.services.Geocoder();

        new daum.Postcode({
          oncomplete: (data) => {

            let addr = ''; // 주소 변수
            let extraAddr = ''; // 참고항목 변수
            let point = '';

            // 사용자가 도로명 주소를 선택했을 경우
            if (data.userSelectedType === 'R') {
              addr = data.roadAddress;

              if(data.bname !== '' && /[동|로|가]$/g.test(data.bname)){
                extraAddr += data.bname;
              }
              // 건물명이 있고, 공동주택일 경우 추가한다.
              if(data.buildingName !== '' && data.apartment === 'Y'){
                extraAddr += (extraAddr !== '' ? ', ' + data.buildingName : data.buildingName);
              }
              // 표시할 참고항목이 있을 경우, 괄호까지 추가한 최종 문자열을 만든다.
              if(extraAddr !== ''){
                extraAddr = ' (' + extraAddr + ')';
              }

              addr = addr + ' ' + extraAddr;

              console.log('도로명', addr);
            } else { // 사용자가 지번 주소를 선택했을 경우(J)
              addr = data.jibunAddress;
              console.log('지번', addr);
            }

            //차고지인경우 좌표값이 필요하다.
            // 주소로 상세 정보를 검색
            geocoder.addressSearch(data.address, (results, status) => {
              // 정상적으로 검색이 완료됐으면
              if (status === daum.maps.services.Status.OK) {

                const result = results[0]; //첫번째 결과의 값을 활용
                console.log('첫번째 결과의 값', result);

                this.address = addr;
                this.addressLat = Number(result.y).toFixed(6);
                this.addressLng = Number(result.x).toFixed(6);
              }
            });
          }
        }).open();
      }
    },

    mounted() {
      let yearsForPregnant = [];
      let years = [];
      let months = [];

      let thisYear = new Date().getFullYear();
      for(let i = BASE_BIRTH_YEAR; i <= thisYear; i++) {
        years.push(i);
      }

      for(let i = thisYear; i < thisYear+5;i++) {
        yearsForPregnant.push(i);
      }
      for(let i=1; i<13; i++) {
        if(i<10) i = '0'+i;
        else i=i+'';
        months.push(i);
      }

      this.selectYears = years;
      this.selectPrgnantYears = yearsForPregnant;
      this.selectMonths = months;
    }

  }
</script>
<style scoped>
  .customer-cu-select {
    width: 50px !important;
    margin: 0 10px !important;
  }
  .customer-cu-em_phone {
    width: 25px !important;
    margin: 0 10px !important;
  }
  .family-contract--add {
    height: 25px !important;
  }
</style>
